export default __webpack_public_path__ + "static/media/avatar.45021614.jpg";